import { DataBroker } from './DataBroker';


const PRAKIM = [
	{	"name": "תהילים בחלוקה לפי ספרים",
		"prakim":	[	{ key:1, name:"ספר ראשון", prakim: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41] },
						{ key:2, name:"ספר שני", prakim: [42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72] },
						{ key:3, name:"ספר שלישי", prakim: [73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89] },
						{ key:4, name:"ספר רביעי", prakim: [90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106] },
						{ key:5, name:"ספר חמישי", prakim: [107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,
															135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150] }
					]
	},
	{	"name": "תהילים בחלוקה לפי ימים",
		"prakim":	[	{ key:6, name:"ליום ראשון", prakim: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29] },
						{ key:7, name:"ליום שני", prakim: [30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50] },
						{ key:8, name:"ליום שלישי", prakim: [51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72] },
						{ key:9, name:"ליום רביעי", prakim: [73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89] },
						{ key:10, name:"ליום חמישי", prakim: [90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106] },
						{ key:11, name:"ליום שישי", prakim: [107,108,109,110,111,112,113,114,115,116,117,118,119] },
						{ key:12, name:"ליום שבת", prakim: [120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150] }
					]
	},
	{	"name": "תהילים - פרקים",
		"wide": true,
		"prakim":	[	{ key:13, name:"פרק א", prakim: [1] },
						{ key:14, name:"פרק ב", prakim: [2] },
						{ key:15, name:"פרק ג", prakim: [3] },
						{ key:16, name:"פרק ד", prakim: [4] },
						{ key:17, name:"פרק ה", prakim: [5] },
						{ key:18, name:"פרק ו", prakim: [6] },
						{ key:19, name:"פרק ז", prakim: [7] },
						{ key:20, name:"פרק ח", prakim: [8] },
						{ key:21, name:"פרק ט", prakim: [9] },
						{ key:22, name:"פרק י", prakim: [10] },

						{ key:23, name:"פרק יא", prakim: [11] },
						{ key:24, name:"פרק יב", prakim: [12] },
						{ key:25, name:"פרק יג", prakim: [13] },
						{ key:26, name:"פרק יד", prakim: [14] },
						{ key:27, name:"פרק טו", prakim: [15] },
						{ key:28, name:"פרק טז", prakim: [16] },
						{ key:29, name:"פרק יז", prakim: [17] },
						{ key:30, name:"פרק יח", prakim: [18] },
						{ key:31, name:"פרק יט", prakim: [19] },
						{ key:32, name:"פרק כ", prakim: [20] },

						{ key:33, name:"פרק כא", prakim: [21] },
						{ key:34, name:"פרק כב", prakim: [22] },
						{ key:35, name:"פרק כג", prakim: [23] },
						{ key:36, name:"פרק כד", prakim: [24] },
						{ key:37, name:"פרק כה", prakim: [25] },
						{ key:38, name:"פרק כו", prakim: [26] },
						{ key:39, name:"פרק כז", prakim: [27] },
						{ key:40, name:"פרק כח", prakim: [28] },
						{ key:41, name:"פרק כט", prakim: [29] },
						{ key:42, name:"פרק ל", prakim: [30] },

						{ key:43, name:"פרק לא", prakim: [31] },
						{ key:44, name:"פרק לב", prakim: [32] },
						{ key:45, name:"פרק לג", prakim: [33] },
						{ key:46, name:"פרק לד", prakim: [34] },
						{ key:47, name:"פרק לה", prakim: [35] },
						{ key:48, name:"פרק לו", prakim: [36] },
						{ key:49, name:"פרק לז", prakim: [37] },
						{ key:50, name:"פרק לח", prakim: [38] },
						{ key:51, name:"פרק לט", prakim: [39] },
						{ key:52, name:"פרק מ", prakim: [40] },

						{ key:53, name:"פרק מא", prakim: [41] },
						{ key:54, name:"פרק מב", prakim: [42] },
						{ key:55, name:"פרק מג", prakim: [43] },
						{ key:56, name:"פרק מד", prakim: [44] },
						{ key:57, name:"פרק מה", prakim: [45] },
						{ key:58, name:"פרק מו", prakim: [46] },
						{ key:59, name:"פרק מז", prakim: [47] },
						{ key:60, name:"פרק מח", prakim: [48] },
						{ key:61, name:"פרק מט", prakim: [49] },
						{ key:62, name:"פרק נ", prakim: [50] },

						{ key:63, name:"פרק נא", prakim: [51] },
						{ key:64, name:"פרק נב", prakim: [52] },
						{ key:65, name:"פרק נג", prakim: [53] },
						{ key:66, name:"פרק נד", prakim: [54] },
						{ key:67, name:"פרק נה", prakim: [55] },
						{ key:68, name:"פרק נו", prakim: [56] },
						{ key:69, name:"פרק נז", prakim: [57] },
						{ key:70, name:"פרק נח", prakim: [58] },
						{ key:71, name:"פרק נט", prakim: [59] },
						{ key:72, name:"פרק ס", prakim: [60] },

						{ key:73, name:"פרק סא", prakim: [61] },
						{ key:74, name:"פרק סב", prakim: [62] },
						{ key:75, name:"פרק סג", prakim: [63] },
						{ key:76, name:"פרק סד", prakim: [64] },
						{ key:77, name:"פרק סה", prakim: [65] },
						{ key:78, name:"פרק סו", prakim: [66] },
						{ key:79, name:"פרק סז", prakim: [67] },
						{ key:80, name:"פרק סח", prakim: [68] },
						{ key:81, name:"פרק סט", prakim: [69] },
						{ key:82, name:"פרק ע", prakim: [70] },

						{ key:83, name:"פרק עא", prakim: [71] },
						{ key:84, name:"פרק עב", prakim: [72] },
						{ key:85, name:"פרק עג", prakim: [73] },
						{ key:86, name:"פרק עד", prakim: [74] },
						{ key:87, name:"פרק עה", prakim: [75] },
						{ key:88, name:"פרק עו", prakim: [76] },
						{ key:89, name:"פרק עז", prakim: [77] },
						{ key:90, name:"פרק עח", prakim: [78] },
						{ key:91, name:"פרק עט", prakim: [79] },
						{ key:92, name:"פרק פ", prakim: [80] },

						{ key:93, name:"פרק פא", prakim: [81] },
						{ key:94, name:"פרק פב", prakim: [82] },
						{ key:95, name:"פרק פג", prakim: [83] },
						{ key:96, name:"פרק פד", prakim: [84] },
						{ key:97, name:"פרק פה", prakim: [85] },
						{ key:98, name:"פרק פו", prakim: [86] },
						{ key:99, name:"פרק פז", prakim: [87] },
						{ key:100, name:"פרק פח", prakim: [88] },
						{ key:101, name:"פרק פט", prakim: [89] },
						{ key:102, name:"פרק צ", prakim: [90] },

						{ key:103, name:"פרק צא", prakim: [91] },
						{ key:104, name:"פרק צב", prakim: [92] },
						{ key:105, name:"פרק צג", prakim: [93] },
						{ key:106, name:"פרק צד", prakim: [94] },
						{ key:107, name:"פרק צה", prakim: [95] },
						{ key:108, name:"פרק צו", prakim: [96] },
						{ key:109, name:"פרק צז", prakim: [97] },
						{ key:110, name:"פרק צח", prakim: [98] },
						{ key:111, name:"פרק צט", prakim: [99] },
						{ key:112, name:"פרק ק", prakim: [100] },

						{ key:113, name:"פרק קא", prakim: [101] },
						{ key:114, name:"פרק קב", prakim: [102] },
						{ key:115, name:"פרק קג", prakim: [103] },
						{ key:116, name:"פרק קד", prakim: [104] },
						{ key:117, name:"פרק קה", prakim: [105] },
						{ key:118, name:"פרק קו", prakim: [106] },
						{ key:119, name:"פרק קז", prakim: [107] },
						{ key:120, name:"פרק קח", prakim: [108] },
						{ key:121, name:"פרק קט", prakim: [109] },
						{ key:122, name:"פרק קי", prakim: [110] },

						{ key:123, name:"פרק קיא", prakim: [111] },
						{ key:124, name:"פרק קיב", prakim: [112] },
						{ key:125, name:"פרק קיג", prakim: [113] },
						{ key:126, name:"פרק קיד", prakim: [114] },
						{ key:127, name:"פרק קטו", prakim: [115] },
						{ key:128, name:"פרק קטז", prakim: [116] },
						{ key:129, name:"פרק קיז", prakim: [117] },
						{ key:130, name:"פרק קיח", prakim: [118] },
						{ key:131, name:"פרק קיט", prakim: [119] },
						{ key:132, name:"פרק קכ", prakim: [120] },

						{ key:133, name:"פרק קכא", prakim: [121] },
						{ key:134, name:"פרק קכב", prakim: [122] },
						{ key:135, name:"פרק קכג", prakim: [123] },
						{ key:136, name:"פרק קכד", prakim: [124] },
						{ key:137, name:"פרק קכה", prakim: [125] },
						{ key:138, name:"פרק קכו", prakim: [126] },
						{ key:139, name:"פרק קכז", prakim: [127] },
						{ key:140, name:"פרק קכח", prakim: [128] },
						{ key:141, name:"פרק קכט", prakim: [129] },
						{ key:142, name:"פרק קל", prakim: [130] },

						{ key:143, name:"פרק קלא", prakim: [131] },
						{ key:144, name:"פרק קלב", prakim: [132] },
						{ key:145, name:"פרק קלג", prakim: [133] },
						{ key:146, name:"פרק קלד", prakim: [134] },
						{ key:147, name:"פרק קלה", prakim: [135] },
						{ key:148, name:"פרק קלו", prakim: [136] },
						{ key:149, name:"פרק קלז", prakim: [137] },
						{ key:150, name:"פרק קלח", prakim: [138] },
						{ key:151, name:"פרק קלט", prakim: [139] },
						{ key:152, name:"פרק קמ", prakim: [140] },

						{ key:153, name:"פרק קמא", prakim: [141] },
						{ key:154, name:"פרק קמב", prakim: [142] },
						{ key:155, name:"פרק קמג", prakim: [143] },
						{ key:156, name:"פרק קמד", prakim: [144] },
						{ key:157, name:"פרק קמה", prakim: [145] },
						{ key:158, name:"פרק קמו", prakim: [146] },
						{ key:159, name:"פרק קמז", prakim: [147] },
						{ key:160, name:"פרק קמח", prakim: [148] },
						{ key:161, name:"פרק קמט", prakim: [149] },
						{ key:162, name:"פרק קנ", prakim: [150] }
					]
	},
	
];




function GetPerekIndex(perekId) {
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);
	return perek.prakim;
};

function RenderShiur(data) {
	return	<div className='Tehilim'>
				<div dangerouslySetInnerHTML={{ __html: data }} />
			</div>;
};

export function GetPerekHeaderTH(perekId) {
	const sefer = PRAKIM.find(m => m.prakim.find(p => p.key == perekId));
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);
	return (sefer.title && (perek.hidePerek===undefined||perek.hidePerek) ? sefer.title+" " : "") + perek.name;
};

export function GetPerekNextTH(perekId) {
	if (perekId == 5)
		return 1;

	if (perekId == 12)
		return 6;

	if (perekId == 162)
		return 13;

	return ++perekId;
};
export function GetPerekPrevTH(perekId) {
	if (perekId == 1) 
		return 5;

	if (perekId == 6) 
		return 12;

	if (perekId == 13) 
		return 162;

	return --perekId;
};



export async function GetPerekTH(perekId) {
	const arrIndex = GetPerekIndex(perekId);

	let data = "";
	let loaded = true;

	for (let i=0; i<arrIndex.length; i++) {
		let tmp = await DataBroker.getDataText('th/' + arrIndex[i]);
		data += tmp;

		if (tmp === null)
			loaded = false;
	}

	return new Promise((myResolve, myReject) => {
		if (!loaded)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(data));
	});
};

export function GetMenuTH() {
	return PRAKIM;
}